import React, { useContext, useEffect } from 'react';
import { Row, Col, Container } from 'reactstrap';
import ContactUsContext from '../../contexts/ContactUsContext';
import ContactCardList from './components/ContactCardList';
import Title from '../../components/Title';
import ErrorPage from '../ErrorPage';
import { createSafeHtml } from '../../utils/sanitizeHtml';

import { ContactUsContainer } from './style';
const ContactUs = () => {
  const { title, dfsModules, description, error } = useContext(ContactUsContext);

  useEffect(() => {
    document.title = "DFS | Contact Us";
  });

  return error ? (
    <ErrorPage />
  ) : (
    <>
      <Container>
        <Row>
          <Col>
            <Title>{title}</Title>
            <ContactCardList contactCards={dfsModules.modules} />
          </Col>
        </Row>
        <Row>
          <Col>
            <ContactUsContainer>
              <div dangerouslySetInnerHTML={createSafeHtml(description)} />
            </ContactUsContainer>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ContactUs;
